<template>
    <span v-if="ShowButtons" class="spanBtnPrincipal">
        <span class="reaction-btn-text btn btn-link text-secondary mb-0">
            <i class="fa fa-ellipsis-v text-xs" aria-hidden="true"></i>
        </span>

        <div class="divBoxIcons">
            <ul class="boxIcons">
                <slot name="bodyBtns"></slot>
            </ul>
        </div>
    </span>
</template>

<script>

export default {
    name:  "CMoreButtons",
    props: ["pShowButtons"],
    data() {
        return {
            ShowButtons: true,
        }
    },
    computed: {
        ValidateLoad()
        {
            if (this.pShowButtons != undefined) {
                this.ShowButtons = this.pShowButtons;
            }
        }
    }
}
</script>